(function () {
  function init() {
    var root = document.getElementById('background-music-root');
    if (!root) return;
    var src = root.getAttribute('data-src');
    if (!src) return;
    var targetVolume = parseFloat(root.getAttribute('data-volume')) || 0.18;

    var audio = document.createElement('audio');
    audio.src = src;
    audio.loop = true;
    audio.preload = 'auto';
    audio.volume = targetVolume;
    audio.style.display = 'none';
    document.body.appendChild(audio);

    var STORAGE_KEY = 'nb_bg_music_muted';
    var userMuted = false;
    try {
      userMuted = window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {}

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Hintergrundmusik ein- oder ausschalten');
    btn.style.cssText = [
      'position:fixed',
      'bottom:20px',
      'right:20px',
      'z-index:9999',
      'width:48px',
      'height:48px',
      'border-radius:50%',
      'border:none',
      'background:#ffffff',
      'box-shadow:0 2px 10px rgba(0,0,0,0.2)',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'cursor:pointer',
      'font-size:20px',
      'line-height:1',
      'padding:0'
    ].join(';');

    function setIcon(playing) {
      btn.textContent = playing ? String.fromCodePoint(128266) : String.fromCodePoint(128263);
    }

    function play() {
      var p = audio.play();
      if (p && typeof p.then === 'function') {
        p.then(function () { setIcon(true); }).catch(function () { setIcon(false); });
      } else {
        setIcon(true);
      }
    }

    function pause() {
      audio.pause();
      setIcon(false);
    }

    if (userMuted) {
      setIcon(false);
    } else {
      play();
      var resumeOnInteract = function () {
        if (audio.paused && !userMuted) play();
      };
      document.addEventListener('click', resumeOnInteract, { once: true });
      document.addEventListener('touchstart', resumeOnInteract, { once: true });
      document.addEventListener('keydown', resumeOnInteract, { once: true });
    }

    btn.addEventListener('click', function () {
      if (audio.paused) {
        userMuted = false;
        try { window.localStorage.setItem(STORAGE_KEY, '0'); } catch (e) {}
        play();
      } else {
        userMuted = true;
        try { window.localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
        pause();
      }
    });

    document.body.appendChild(btn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
